<template>
  <el-container class="pay-successful">
    <!-- <SidebarMenus /> -->
    <el-container class="main-container">
      <!-- <el-header class="header">
				<div class="header-content">
					<img src="../../../assets/logo-text.png" alt="OxpeckerLogo" class="logo" />
					<div class="user-info">
						<span class="username">CHRIS</span>
						<img src="../../../assets/codeScan/account-circle.png" alt="User Icon" class="user-icon" />
					</div>
				</div>
			</el-header> -->
      <el-main class="main-content">
        <div class="content-header">
          <h2><img src="../../../assets/codeScan/antFill-pay-circle.png" /> {{ $t('paySuccessful.payment') }}</h2>
        </div>
        <div class="content">
          <div
            class="tip"
            v-if="success"
          >
            <img src="../../../assets/codeScan/pay-successful.png" />
            <h1>{{ $t('paySuccessful.paymentSuccessful') }}</h1>
            <div class="message-container">
              <div class="main-ms">{{ $t('paySuccessful.thankYou') }}</div>
              <div class="main-mss">{{ $t('paySuccessful.viewVulnerabilityInfo') }}</div>
            </div>
            <button
              class="entropool"
              @click="entropool"
            >{{ $t('paySuccessful.backToVulnerabilityList') }}</button>
          </div>
          <div
            class="tips"
            v-else
          >
            <img
              class="failed"
              src="../../../assets/codeScan/pay-failed.png"
            />
            <h1>{{ $t('paySuccessful.paymentFailed') }}</h1>
            <div class="message-container">
              <div class="main-mss">{{ $t('paySuccessful.tryAgain') }}</div>
            </div>
            <button
              class="entropool"
              @click="entropool"
            >{{ $t('paySuccessful.backToCheckout') }}</button>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// import SidebarMenus from '@/components/SidebarMenus.vue';
export default {
  name: 'PaySuccessful',
  components: {
    // SidebarMenus
  },
  data() {
    return {
      success: true,
    };
  },
  methods: {
    entropool() {
      this.$router.replace({ name: 'ReportsView', query: { taskId: this.$route.query.taskId } });
    },
  },
};
</script>

<style lang="scss">
.pay-successful {
  width: 100%;
  display: flex;
  // background-color: #f5f5f5;

  .main-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 80px);
  }

  .sidebar {
    height: calc(100vh - 85px);
    margin: 50px 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  .el-menu {
    background: linear-gradient(to bottom, #e9eef2, #fff);
    height: calc(100vh - 85px);
    border-radius: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    margin: 0;
    border-radius: 10px;
    width: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .main-content {
    flex: 1;
    // background-color: #fff;
    background: linear-gradient(to bottom, #e9eef2, #fff);
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .logo {
    width: 150px;
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .username {
    margin-right: 10px;
  }

  .user-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    background-color: #f6f6f6;
    border-radius: 10px;
    padding: 0px 20px;
    height: 55px;
    line-height: 54px;

    h2 {
      font-size: 20px;
      padding-left: 10px;
    }

    img {
      width: 30px;
      height: 30px;
      position: relative;
      top: 7px;
      right: 5px;
    }
  }

  .content {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    height: calc(100vh - 205px);

    .tip {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      img {
        width: 270px;
        height: auto;
      }

      h1 {
        font-size: 24px;
      }

      .message-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
      }

      .main-ms {
        font-size: 16px;
        color: #8e8e8e;
        margin-bottom: 10px;
      }

      .main-mss {
        font-size: 14px;
        color: #8e8e8e;
      }

      .entropool {
        font-size: 16px;
        background-color: #2b2b2b;
        color: #ffffff;
        width: 350px;
        height: 55px;
        line-height: 55px;
        border-radius: 5px;
        margin-top: 74px;
        font-size: 20px;
        text-align: center;
        cursor: pointer;
      }
    }

    .tips {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      img {
        width: 10%;
        height: 10%;
        margin-top: 50px;
      }

      h1 {
        font-size: 30px;
        margin-top: 20px;
      }

      .message-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
      }

      .main-mss {
        font-size: 20px;
        color: #8e8e8e;
        font-weight: 600;
      }

      .entropool {
        font-size: 16px;
        background-color: #2b2b2b;
        color: #ffffff;
        width: 350px;
        height: 55px;
        line-height: 55px;
        border-radius: 5px;
        margin-top: 78px;
        font-size: 20px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>